import React                    from 'react';
import PropTypes                from 'prop-types';
import Block                    from '../Block';
import Header                   from './Header';
import Translations             from '../../../utils/Translations';
import ButtonRow                from './ButtonRow';
import Flux                     from '../../../flux/Flux';
import {trackClick}             from '../../../utils/GAHelper';
import Grid2                    from "../../Grid2/Grid2";
import ActorTile                from "../../Grid2/Tiles/ActorTile";
import withActors               from '../../HigherOrderComponents/Actors/withActors';
import withStaticLoader         from '../../HigherOrderComponents/Utility/withStaticLoader';
import ActorContactContainer    from '../../TileGrid/Tile/ActorContactContainer';

const PRESET   = Flux.Constants.Vxql.Actors.Presets.NEW_GIRLS;
const GRID_ID  = 'home-new-girls-grid';
const Grid     = withActors(withStaticLoader(Grid2));

class NewGirlsBlock extends React.Component {
	constructor(props) {
		super(props);

		this.state   = {
			total:  0,
			tiles:  this.getTilesByWindowSize(),
			order:  Flux.Constants.Vxql.Actors.Order.ONLINE_RANKING,
			filter: {},
			loading: true,
		};

		this.onResize                = this.onResize.bind(this);
		this.getActorsTotalFromStore = this.getActorsTotalFromStore.bind(this);
		this.onActorDataChange       = this.onActorDataChange.bind(this);
		this.onActorDataLoadChange   = this.onActorDataLoadChange.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addWindowResizeListener(this.onResize);
		Flux.Actors.addActorsDataChangeListener(this.onActorDataChange);
		Flux.Actors.addActorsDataLoadListener(this.onActorDataLoadChange);
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.onResize);
		Flux.Actors.removeActorsDataChangeListener(this.onActorDataChange);
		Flux.Actors.removeActorsDataLoadListener(this.onActorDataLoadChange);
	}

	onActorDataChange(id) {
		if (id !== GRID_ID) {
			return;
		}
		const total  = this.getActorsTotalFromStore();
		this.setState({total});
	}

	onActorDataLoadChange() {
		const loading = Flux.Actors.isActorsDataLoading(this.state.filter, this.state.order, PRESET);
		const total   = this.getActorsTotalFromStore();
		this.setState({loading, total});
	}

	getActorsTotalFromStore() {
		return Flux.Actors.getActorsTotalCount(this.state.filter, this.state.order, PRESET) || 0;
	}

	onResize() {
		this.setState({
			tiles: this.getTilesByWindowSize(),
		});
	}

	getTilesByWindowSize() {
		if (this.props.isMobile) {
			return 1;
		} else if (Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm) {
			return 8;
		} else if (Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md) {
			return 6;

		} else if (Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.lg) {
			return 8;
		}
		return 5;
	}

	render() {
		const first   = this.props.isMobile ? 1 : 8;
		const columns = this.props.isMobile ? {xs: 1} : {xs: 2, sm: 3, md: 4, lg: 5};

		return (
			<Block className="new-girls" idName="new-girls-block">
				<Header
					title={this.props.title}
					hasCount={true}
					count={this.state.total}
					countLabel={Translations.get('HomepageNewAmateursCount')}
					headlineType={this.props.headlineType}
				/>
				<Grid
					//Grid2
					defaultTileClass={ActorTile}
					columns={columns}
					tilePadding={Flux.Constants.Grid2.TilePadding.SMALL}
					headlineType={'h3'}
					defaultTileConfig={{container: this.props.isMobile ? null : ActorContactContainer, isNewGirlStyle: true}}

					//Loader
					useFullscreenLoader={false}
					loading={this.state.loading}

					//withActors
					removeSedcard={true}
					preset={Flux.Constants.Vxql.Actors.Presets.NEW_GIRLS} 
					first={first}
					filter={this.state.filter}
					order={this.state.order}
					offset={0}
					id={GRID_ID}
					isLoadMore={false}
					useCache={false}
					total={this.state.total}
					isMobile={this.props.isMobile}
					maxTiles={this.state.tiles}
				/>
				<ButtonRow
					cta={Translations.get('HomepageNewAmateursCTA')}
					link={this.props.link}
					callback={() => trackClick('newgirls', this.props.link)}
				/>
			</Block>
		);
	}
}

NewGirlsBlock.propTypes = {
	link:             PropTypes.string.isRequired,
	isMobile:         PropTypes.bool.isRequired,
	lazyImageLoading: PropTypes.bool,
	headlineType:     PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
	title:            PropTypes.string,
};

NewGirlsBlock.defaultProps = {
	lazyImageLoading: false,
	headlineType:     Flux.Constants.Headlines.h2,
	title:            Translations.get('HomepageNewAmateursTitle'),
};

export default NewGirlsBlock;
